<script setup lang="ts">

</script>

<template>
    <v-chip
        variant="flat"
        color="#B8E2C2"
        size="x-small"
        class="text-green-darken-4 mr-1 px-2 text-caption"
    >
        <v-icon
            color="#167538"
            class="mr-1"
            size="small"
        >
            mdi-file-document-check-outline
        </v-icon>
        Published
    </v-chip>
</template>

<style scoped>

</style>
